import {Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[msPreventLineBreaks]',
  standalone: true,
  host: {
    '(paste)': 'onPaste($event)',
    '(keydown.shift.enter)': 'onKeyDown($event)',
    '(keydown.enter)': 'onKeyDown($event)',
  },
})
export class PreventLineBreaksDirective {
  constructor(private readonly element: ElementRef) {}

  onPaste(e: ClipboardEvent) {
    const fieldEl = this.element.nativeElement;
    const oldClipboardData = e.clipboardData.getData('text/plain');
    const newClipboardData = oldClipboardData.replace(/\r?\n|\r/g, '');

    const startPos = fieldEl.selectionStart;
    const endPos = fieldEl.selectionEnd;

    let newValue =
      fieldEl.value.substring(0, startPos) + newClipboardData + fieldEl.value.substring(endPos, fieldEl.value.length);

    if (fieldEl.maxLength < newValue.length) {
      newValue = newValue.substr(0, this.element.nativeElement.maxLength);
    }

    let cursorPos = endPos + newClipboardData.length;
    cursorPos = cursorPos > fieldEl.maxLength ? fieldEl.maxLength : cursorPos;

    fieldEl.focus();
    fieldEl.value = newValue;
    fieldEl.selectionEnd = cursorPos;
    fieldEl.dispatchEvent(new Event('input'));

    e.preventDefault();
  }

  onKeyDown(e: Event) {
    e.preventDefault();
  }
}
